// Welle D3b: Einstellungen › „Startseite anpassen“ öffnet Heute direkt im Anpassen-Modus.
// Einmal-Flag in sessionStorage — Heute liest und löscht es beim Öffnen.
import { globalNav } from '../../../lib/nav';

export const BOARD_ANPASSEN_KEY = 'ld-board-anpassen';

export function oeffneBoardAnpassen() {
  try { sessionStorage.setItem(BOARD_ANPASSEN_KEY, '1'); } catch { /* ohne Flag öffnet Heute normal */ }
  globalNav('home');
}
